export default "__VITE_ASSET__c7188d56__"